<template>
    <Row class="header-collapse">
      <Col span="5">
        <Collapse simple>
          <Panel hide-arrow>
            <b class="panel-name">{{ account_name }}</b>
            <div
              v-for="(item, index) of account_info"
              :key="index"
              slot="content"
              class="panel-content"
            >
              <p>
                <b>{{ item.name }}:</b>
                {{ item.value }}
              </p>
            </div>
          </Panel>
        </Collapse>
      </Col>
    </Row>
</template>

<script>
export default {
  name: 'child_header_view',
  props: ['account_info', 'account_name'],
  data: function () {
    return {
      
    }
  }
};
</script>
    
<style scoped>
.header-collapse {
  background-color: rgba(255, 255, 255, 0.2);
}
.panel-name {
  display: flex;
  font-size: 18px;
  color:#893448;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
.panel-content {
  font-size: 15px;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
</style>